import React from 'react';
export default function useResizeObserver(callback, target) {
    React.useEffect(function () {
        var resizeObserver = new ResizeObserver(function (entries) {
            callback(entries);
        });
        resizeObserver.observe(target);
        return function () {
            resizeObserver.disconnect();
        };
    }, []);
}
